import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import routes from '../routes/routes'
import unitService from '../services/unit.service'
import unitApi, { UnitData } from '../apis/unit.api'
import categoryApi, { CategoryUpdateRequest } from '../apis/category.api'
import ContentLayout from '../components/ContentLayout'
import ContentMain from '../components/ContentMain'
import Card from '../components/Card'
import CardButton from '../components/CardButton'
import Row from '../components/Row/Row'
import InputText from '../components/InputText'
import Select from '../components/Select'
import PageHeading from '../components/PageHeading'

interface CategoryEditRouteState {
  id: number
}

interface CategoryEditProps
  extends RouteComponentProps<any, any, CategoryEditRouteState> {}

interface CategoryEditState {
  name: string
  unit: string
  units: UnitData[]
}

class CategoryEdit extends Component<CategoryEditProps, CategoryEditState> {
  constructor (props: CategoryEditProps) {
    super(props)
    this.state = {
      name: '',
      unit: '',
      units: []
    }
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleSaveClick = this.handleSaveClick.bind(this)
  }

  get id () {
    return this.props.location.state.id
  }

  get unitSelectOptions () {
    return unitService.selectOptions(this.state.units)
  }

  save () {
    const { name, unit } = this.state
    const payload: CategoryUpdateRequest = {}
    if (name) payload.category = name
    if (unit) payload.type = Number(unit)
    categoryApi.update(this.id, payload, category => {
      if (!category) return
      this.props.history.push(routes.categories)
    })
  }

  handleInputChange (name: string, value: string) {
    if (name === 'name') this.setState({ name: value })
    if (name === 'unit') this.setState({ unit: value })
  }

  handleSaveClick () {
    this.save()
  }

  readCategory () {
    categoryApi.read(this.id, category => {
      if (!category) return
      const { name, unitId } = category
      this.setState({ name, unit: String(unitId) })
    })
  }

  listUnits () {
    unitApi.list(units => {
      if (!units) return
      this.setState({ units })
    })
  }

  componentDidMount () {
    this.readCategory()
    this.listUnits()
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="oneThird">
          <Card>
          <PageHeading
            text={i18n("Edit Category")}
            doc='categories-edit-category' />
          <Row column={1}>
            <InputText
              name="name"
              value={this.state.name}
              label={i18n("Category")}
              onChange={this.handleInputChange} />
            <Select
              name="unit"
              value={this.state.unit}
              options={this.unitSelectOptions}
              label={i18n("Type")}
              onChange={this.handleInputChange} />
          </Row>
          <CardButton
            proceedText={i18n("Save")}
            cancelText={i18n("Cancel")}
            onProceedClick={this.handleSaveClick} />
          </Card>
        </ContentMain>
      </ContentLayout>
    )
  }
}

export default withRouter(CategoryEdit)
